import { AsyncPipe, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CallPipe } from '../../pipes/call.pipe';
import { SmartInputEntityComponent } from '../smart-input-entity/smart-input-entity.component';
import { WorkPackageStatusPickerHandler } from '../smart-input-entity/wp-status-picker.handler';
import { BaseFeatureDto, WorkPackageStatusDto } from '@api/backend-connector/models';
import { WPStatusBadgeComponent } from 'src/app/components/wp-card/wp-status-badge/wp-status-badge.component';
import { TemplateDirective } from 'src/app/directives/template.directive';
import { WorkPackageStatusService } from 'src/app/services/work-package-status.service';
import { cast } from 'src/app/utils';

export type WPStatusPickable = Pick<WorkPackageStatusDto, 'id' | 'name' | 'color'> | BaseFeatureDto;

@Component({
  selector: 'app-wp-status-picker',
  templateUrl: './wp-status-picker.component.html',
  styleUrl: './wp-status-picker.component.scss',
  standalone: true,
  imports: [
    AsyncPipe,
    CallPipe,
    FormsModule,
    NgStyle,
    NgTemplateOutlet,
    ReactiveFormsModule,
    TemplateDirective,
    TranslateModule,
    WPStatusBadgeComponent,
    SmartInputEntityComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WPStatusPickerComponent {
  private readonly workPackageStatusesService = inject(WorkPackageStatusService);

  readonly control = input.required<FormControl<WPStatusPickable | null | undefined>>();
  readonly placeholder = input('');
  readonly resetValue = input<WPStatusPickable | undefined>();
  readonly excludeIds = input<string[] | null>();

  readonly workPackagePickerHandler = computed(() => {
    void this.resetValue();
    return new WorkPackageStatusPickerHandler(this.workPackageStatusesService);
  });

  readonly cast = cast<WPStatusPickable>;

  constructor() {
    effect(() => {
      this.workPackagePickerHandler().setExcludeIds(this.excludeIds() ?? []);
    });
  }
}
